import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ProductContainer } from "../styled/setting";
import Preview from "./preview";
import { BsChevronLeft } from "react-icons/bs";
import Options from "./product/options";
import Actions from "./product/actions";
import { useParams } from "react-router";

const Product = ({ product, toggleProduct }) => {
  const { cmpnyNo } = useParams();
  const [options, setOptions] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [productQuantity, setProductQuantity] = useState(1);

  useEffect(() => {
    if (!product) {
      setOptions(null);
      setSelectedOptions({});
      setProductQuantity(1);
    } else {
      getOption();
    }
  }, [product]);

  const getOption = async () => {
    const url = "/erp/option/get";
    const body = { vendorProductId: product.id, admin: false };
    const res = await axios.post(url, body);
    if (res.status === 200) {
      console.log(res.data);
      setOptions(res.data);
    }
  };

  const changeProductQuantity = (quantity) => {
    if (quantity < 1) return;
    if (quantity > productQuantity) {
      setProductQuantity(quantity);
      return;
    }
    setProductQuantity(quantity);
  };

  const optionTotalPrice = Object.values(selectedOptions).reduce(
    (sum, opt) => sum + (opt?.addPrice || 0),
    0,
  );
  const unitPrice = (product?.price || 0) + optionTotalPrice;
  const calculatedTotalPrice = unitPrice * (productQuantity || 1);

  const validationCheck = () => {
    if (!product?.price) {
      toast.error("해당 상품은 장바구니에 담을 수 없습니다.");
      return false;
    }
    if (!Array.isArray(options) || options.length === 0) return true;
    for (const group of options) {
      if (group.isRequired) {
        const key = group?.id ?? group?.name;
        if (!selectedOptions[key]) {
          toast.error(`${group?.name} 옵션을 선택해주세요.`);
          return false;
        }
      }
    }
    return true;
  };

  const buildProductInfo = () => {
    const selected = Object.values(selectedOptions) || [];
    const mappedOptions = selected.map((opt) => {
      const group = (options || []).find((g) => (g.options || []).some((o) => o.id === opt.id));
      return {
        optionGroupName: group?.name || "",
        optionId: opt.id,
        qty: opt?.consumeCount || 1,
        name: opt?.value || "",
        price: opt?.addPrice || 0,
      };
    });
    return {
      id: product.id,
      vendorProductId: product.id,
      quantity: productQuantity,
      checked: true,
      options: mappedOptions,
    };
  };

  const upsertCart = async () => {
    if (!validationCheck()) return;
    const productInfo = buildProductInfo();
    try {
      const raw = localStorage.getItem(`mbCart:${cmpnyNo}`);
      const current = JSON.parse(raw || "[]");
      const next = Array.isArray(current) ? [...current] : [];

      const isSameOptions = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        const sa = [...a].sort((x, y) => x.optionId - y.optionId);
        const sb = [...b].sort((x, y) => x.optionId - y.optionId);
        return sa.every(
          (x, i) => x.optionId === sb[i].optionId && (x.qty ?? 1) === (sb[i].qty ?? 1),
        );
      };

      const found = next.find(
        (it) =>
          it.vendorProductId === productInfo.vendorProductId &&
          isSameOptions(it.options, productInfo.options),
      );
      if (found) {
        found.quantity = (found.quantity || 1) + (productInfo.quantity || 1);
      } else {
        next.push({
          productName: product?.name || "",
          productPrice: product?.price || 0,
          productImageUrl: JSON.stringify(product?.media || []),
          ...productInfo,
        });
      }
      localStorage.setItem(`mbCart:${cmpnyNo}`, JSON.stringify(next));
      toggleProduct(null);
    } catch (e) {}
  };

  return (
    <ProductContainer className={product ? "active" : "inactive"}>
      <button onClick={() => toggleProduct(null)}>
        <BsChevronLeft />
      </button>
      <div className="content">
        <Preview image={product?.media} info={product?.name} objectFit="contain" />
        <p className="price">{formatNumber(product?.price)}원</p>
        <Options
          options={options}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
        />
        <Actions
          productQuantity={productQuantity}
          changeProductQuantity={changeProductQuantity}
          calculatedTotalPrice={calculatedTotalPrice}
        />
        <div className="desc">{product?.shortDescription}</div>
      </div>
      <button className="submit" onClick={upsertCart}>
        담기
      </button>
    </ProductContainer>
  );
};

export default Product;
